import FilterCheckBoxComp from 'components/UIComponents/FilterCheckBoxComp'
import { getFilterRoleList } from 'modules/InterviewerDashboard/actions'
import { Wrapper } from 'modules/Roles/Partials/RolesFilter/Styles/style'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'

const JobTypeFilter = ({ roleFilter, setRoleFilter }) => {
  const params = useParams()
  const dispatch = new useDispatch()
  const [rolesList, setRolesList] = useState([])
  const UserData = useSelector(state => state?.auth?.userData)
  useEffect(() => {
    ;(async () => {
      const UserId = params?.userId ? params?.userId : UserData?._id
      let responce = await dispatch(getFilterRoleList(UserId))
      setRolesList(responce?.roleDetails)
    })()
    return () => {}
  }, [])

  return (
    <Wrapper column>
      <FilterCheckBoxComp
        value={roleFilter}
        options={rolesList}
        onChange={value => setRoleFilter(value)}
        valueParam="id"
        labelParam="tittle"
      />
    </Wrapper>
  )
}

export default JobTypeFilter
